import ModalsLib from '../../../../lib/modals';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/tasks/daily/crypto_deposit';
import Diamond from '../diamond';

export default () => {
    const {task} = useSelector(Selector);

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/crypto.png`} alt="Crypto Icon" />
                </div>
                <div className="title">Crypto Deposit</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Make deposit from $20 in crypto and claim your diamond reward.
                </div>
                {(task.completed || task.redeemed) ? (
                    <div className="button-block completed">
                        Completed
                    </div>
                ) : (
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            ModalsLib.open('wallet');
                        }}>
                            Deposit
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}